/**
 * Der parameterTyp NUMBER gibt null für Werte zurück, welche keine Zahl sind. Sonst die Zahl.
 * @type {string}
 */
import { removeEmptyValues } from "./ObjectUtils";

export const NUMBER = "number";

/**
 * Der parameterTyp STRING gibt den ausgelesenen Parameter als solchen zurück.
 * @type {string}
 */
export const STRING = "string";

/**
 * Kombiniert alle Objekte zu einem Query-String, welcher hinter ein "?" in eine Abfrage-URL gepackt werden kann
 * @param obj das zu parsende Objekt
 * @returns {string} der Query-String
 */
export function toQueryString(obj) {
    return Object.keys(obj)
        .filter((key) => obj[key])
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join("&");
}

/**
 * Wandelt das Objekt in einen Base64Parameter um, welcher an das Backend als Queryparameter gesendet werden kann
 * @param obj
 */
export function toBase64QueryParam(obj) {
    removeEmptyValues(obj);
    return Buffer.from(JSON.stringify(obj)).toString("base64");
}

/**
 * Util Funktion, welche durch Parameter-Hooks aufgerufen wird
 * @param value
 * @param paramType
 * @param missingValue
 * @param paramValue
 * @param setParamValue
 */
export function setChangedParam(value, paramType, missingValue, paramValue, setParamValue) {
    let val = value;
    if (paramType) {
        if (paramType === NUMBER) {
            val = isNaN(val) ? missingValue : Number(val);
        }
        if (paramType === STRING) {
            val = val ? val : missingValue;
        }
    }
    if (val !== paramValue) {
        setParamValue(val);
    }
}
